var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"configExplorer"},[_c('h3',[_vm._v("Current Configuration")]),_c('pre',[_vm._v(_vm._s(_vm.config))])])
}
var staticRenderFns = []

export { render, staticRenderFns }